import axios from "axios";
import { config } from "../../config";
import { deleteEmptyProp } from "../../helpers";

export class ProductsService {
  public pagination = async (filter?: any): Promise<any> => {
    try {
      const { serverUrl } = config;
      const params = deleteEmptyProp(filter);
      const response = await axios.get(serverUrl + `products`, { params });
      return response.data;
    } catch (err: any) {
      return {};
    }
  };

  public list = async (): Promise<any> => {
    try {
      const { serverUrl } = config;
      const response = await axios.get(serverUrl + `products/all`);
      return response.data;
    } catch (err: any) {
      return {};
    }
  };

  public add = async (data: any): Promise<any> => {
    try {
      const { serverUrl } = config;
      const response = await axios.post(serverUrl + `products`, data);
      return response.data;
    } catch (err: any) {
      return {};
    }
  };

  addDocument = async (productId: number, data: any): Promise<any> => {
    try {
      const { serverUrl } = config;
      const response = await axios.post(
        serverUrl + `products/${productId}/document`,
        data,
      );
      return response.data;
    } catch (err: any) {
      return {};
    }
  };

  public update = async (id: string, data: any): Promise<any> => {
    try {
      const { serverUrl } = config;
      const response = await axios.put(serverUrl + `products/${id}`, data);
      return response.data;
    } catch (err: any) {
      return {};
    }
  };

  public updateStatus = async (id: string, status: string): Promise<any> => {
    try {
      const { serverUrl } = config;
      const response = await axios.put(serverUrl + `products/${id}/status`, {
        status,
      });
      return response.data;
    } catch (err: any) {
      return {};
    }
  };

  public get = async (id: string): Promise<any> => {
    try {
      const { serverUrl } = config;
      const response = await axios.get(serverUrl + `products/${id}`);
      return response.data;
    } catch (err: any) {
      return {};
    }
  };
}
